import { createAction, props } from '@ngrx/store';
import { BusinessInformation } from './../../interfaces/business-information';

enum BusinessInformationActions {
    loadBusinessInformation = '[Business Information] Load Business Information',
    setBusinessInformation = '[Business Information] Set Business Information Success',
    resetBusinessInformation = '[Business Information] Reset Business Information'
}

export const LoadBusinessInfoAction = createAction(
    BusinessInformationActions.loadBusinessInformation
);

export const ResetBusinessInfoAction = createAction(
    BusinessInformationActions.resetBusinessInformation
);

export const SetBusinessInfoAction = createAction(
    BusinessInformationActions.setBusinessInformation,
    props<BusinessInformation>()
);